module.exports = __webpack_public_path__ + "static/media/logo.368a6bfe7f8f4b3e883a6a949ccfab53.svg";